<template>
  <WdsStack direction-column gap-md>
    <slot />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsStack } from '@worksome/wds-components'
</script>
